<template>
  <div>
    <b-modal
      v-model="showNotForNavigation"
      size="md"
      title="Warning"
      hide-footer
      @hidden="handleNotForNavigationOk"
    >
      <template #modal-title>
        <div class="warning-modal-title">
          <span class="title-label">
            <i class="fas fa-exclamation-triangle" />
            Navigation Warning
          </span>
        </div>
      </template>
      <div class="warning-card">
        <div class="warning-content">
          <div class="warning-icon">
            <i class="fas fa-ship" />
          </div>
          <div class="warning-text">
            <h4 class="warning-heading">
              NOT FOR NAVIGATION
            </h4>
            <p class="warning-description">
              This system is intended for route planning purposes only. Do not use this information for actual navigation. Always refer to official nautical charts and navigation equipment.
            </p>
          </div>
        </div>
        <b-button
          @click="handleNotForNavigationOk"
          size="sm"
          variant="primary"
          block
          class="acknowledge-button"
        >
          I Understand
        </b-button>
      </div>
    </b-modal>

    <b-modal v-model="show2D" title="UKC Calculation" @ok="okPressed" @cancel="cancelPressed">
      <span class="listsmall">{{ $t('route.routeName') }}:</span>
      {{ routesStore.getRouteName }} (
      <a href="#" @click="changeSettings()">{{ $t('route.change') }}</a>
      )
      <br>
      <span class="listsmall">{{ $t('route.nogo') }}</span>
      {{ routesStore.getShipNoGo }} m (
      <a href="#" @click="changeSettings()">{{ $t('route.change') }}</a>
      )
      <br>
      <span class="listsmall">{{ $t('route.draught') }}:</span>
      {{ routesStore.getShipDraught }} m (
      <a href="#" @click="changeSettings()">{{ $t('route.change') }}</a>
      )
      <br>
      <span class="listsmall">{{ $t('route.length') }}:</span>
      {{ routesStore.getShipLength }} m (
      <a href="#" @click="changeSettings()">{{ $t('route.change') }}</a>
      )
      <br>
      <span class="listsmall">{{ $t('route.width') }}:</span>
      {{ routesStore.getShipWidth }} m (
      <a href="#" @click="changeSettings()">{{ $t('route.change') }}</a>
      )
      <br>
      <span class="listsmall">{{ $t('route.height') }}:</span>
      {{ routesStore.getShipHeight }} m (
      <a href="#" @click="changeSettings()">{{ $t('route.change') }}</a>
      )
      <br>
      <span class="listsmall">{{ $t('route.displacement') }}:</span>
      {{ routesStore.getShipDisplacement }} m (
      <a href="#" @click="changeSettings()">{{ $t('route.change') }}</a>
      )
      <br>
    </b-modal>
  
    <b-modal v-model="showRouteNameModal" :title="$t('route.saveRoute')" @ok="handleRouteNameOk" ok-only>
      <b-form-group :label="$t('route.routeName')" label-for="route-name-input">
        <b-form-input id="route-name-input" v-model="routeNameInput" :placeholder="$t('route.enterRouteName')" />
      </b-form-group>
    </b-modal>
  
    <b-modal :title="$t('msg.agreementWarning')" v-model="isNeedCheckSafetyWarning" ok-only>
      <div class="text-sm-left" id="up">
        {{ $t('route.checkRouteFirst') }}
      </div>
    </b-modal>
  
    <b-modal :title="$t('msg.routeValidation')" v-model="hasRouteValidationMessage" ok-only no-close-on-backdrop
      no-close-on-esc @ok="ackRouteValidation">
      <div class="text-sm-left" id="routeValidation">
        {{ routeValidationMessage }}
      </div>
    </b-modal>
  
    <b-overlay :show="
                      !userStore.isShipsLoaded ||
                      momentaryStore.isBusy1 ||
                      $store.state.routes.progress.isCalculating ||
                      is_catalog_preparing ||
                      is_items_by_route_preparing
                    " bg-color="white" class="mt-1" :opacity="getOverlayOpacity">
      <template #overlay>
        <div v-if="is_catalog_preparing" class="text-center">
          <b-icon icon="hourglass" font-scale="2" animation="spin" />
          <p>{{ $t('route.loadingCatalog') }}</p>
        </div>
  
        <div v-if="is_items_by_route_preparing" class="text-center">
          <b-icon icon="hourglass" font-scale="2" animation="spin" />
          <p>{{ $t('route.loadingProducts') }}</p>
        </div>
  
        <div v-if="momentaryStore.isBusy1" class="text-center">
          <b-icon icon="hourglass" font-scale="2" animation="spin" />
          <p>{{ $t('route.loading') }}</p>
        </div>
  
        <!-- <div v-if="!userStore.isShipsLoaded || !deviceStore.isAgreementLoaded" class="text-center">
          <b-icon icon="hourglass" font-scale="2" animation="spin" />
          <p v-if="!userStore.isShipsLoaded">
            {{ $t('route.loadingShips') }}
          </p>
          <p v-if="userStore.isShipsLoaded && !deviceStore.isAgreementLoaded">
            {{ $t('route.loadingAgreements') }}
          </p>
        </div> -->
  
        <div v-if="$store.state.routes.progress.isCalculating" class="text-center">
          <b-card>
            <p id="cancel-label">
              {{ getProgressTitle }}
            </p>
            <b-progress class="mt-2" :max="100" show-value show-progress animated>
              <b-progress-bar :value="routingProgress()" :label="`${routingProgress()}%`" variant="primary" />
            </b-progress>
            <p v-if="$store.state.routes.progress.text" class="mt-1 small text-center">
              {{ $store.state.routes.progress.text }}
            </p>
            <b-button class="mt-2" size="sm" @click="cancelRoute()" variant="danger">
              {{ $t('route.cancel') }}
            </b-button>
          </b-card>
        </div>
      </template>
  
      <b-container fluid>
        <b-row class="py-0 my-0 align-items-center" style="min-height: 0">
          <b-col :lg="getTabSize()" class="py-0 my-0">
            <b-button-group block class="btn-block" compact-button-group>
              <b-button :variant="getRouteButtonStatus('ports')" size="sm" @click="showPorts()">
                {{ $t('tabs.ports') }}
              </b-button>
              <b-button :variant="getRouteButtonStatus('routes')" size="sm" @click="showRoutes()">
                {{ $t('tabs.routes') }}
              </b-button>
              <b-button :variant="getRouteButtonStatus('settings')" size="sm" :disabled="momentaryStore.isUKCLoaded"
                @click="showSettings()">
                {{ $t('tabs.settings') }}
              </b-button>
            </b-button-group>
          </b-col>
          <b-col class="py-0 my-0 text-left">
            <div class="d-flex align-items-center">
              <div class="ship-badge" :class="{ 'ship-badge--clickable': hasOwnShipPosition }" @click="centerMapOnShip">
                <span>{{ getShipName }}</span>
              </div>
            </div>
          </b-col>
          <!-- <b-col class="py-0 my-0 text-center text-danger">
            NOT FOR NAVIGATION  
          </b-col> -->
          <b-col class="py-0 my-0 text-right">
            {{ breadcrumbText }}
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col v-show="displayContent === 'showRoute'" order="4" order-lg="1" :lg="getTabSize()">
            <b-row>
              <b-col>
                <div class="d-flex align-items-center">
                  <b-form-select :disabled="select_ship_disabled" v-model="selected_ship" :options="ships"
                    :title="getSelectedShipTooltip" v-b-tooltip.hover size="sm" />
                  <span class="ml-2 small-gray">{{ deviceStore.getAgreementProvider }}</span>
                </div>
              </b-col>
            </b-row>
  
            <b-tabs card v-model="tabIndex" small class="compact-tabs">
              <b-tab :title="$t('tabs.files')">
                <div class="mt-2">
                  <b-form-file v-model="pathFile" id="upload-path" accept=".json" class="d-none" />
                  <b-form-file v-model="routeFile" id="upload-route" accept=".rtz" class="d-none" />
                  <b-form-file v-model="zonesFile" id="upload-zones" class="d-none" />
  
                  <b-button size="sm" variant="info" class="mr-1" @click="loadZonesFile()">
                    {{ $t('route.loadZones') }}
                  </b-button>
                  <b-button v-if="IS_DEVBUILD()" size="sm" variant="info" class="mr-1" @click="loadPathFile()">
                    {{ $t('route.loadPaths') }}
                  </b-button>
                  <b-button size="sm" variant="info" class="mr-1" @click="loadRouteFile()">
                    {{ $t('route.loadRTZ') }}
                  </b-button>
                  <b-button size="sm" variant="info" :disabled="routesStore.getShipWaypointsCount < 2" @click="saveRTZ()">
                    {{ $t('route.saveRTZ') }}
                  </b-button>
                  &nbsp;
                  <!--                    <b-button size="sm" variant="info" @click="saveRouteFile()">Save Route</b-button>&nbsp;-->
                </div>
              </b-tab>
              <b-tab :title="$t('tabs.generalRoute')" @click="tabNonAIOClicked()">
                <GeneralRouteTable ref="generalRoute-tab" />
              </b-tab>
              <b-tab :title="$t('tabs.wp')" active @click="tabNonAIOClicked()">
                <RouteTable ref="route-tab" v-if="routesStore.getShipWaypointsCount > 0" :fields="fields" />
              </b-tab>
              <b-tab @click="tabPassagePlanClicked()" :title="$t('tabs.ukc')" :title-item-class="getTabStatus()">
                <passage-plan-table ref="passage-plan-table" />
              </b-tab>
              <b-tab @click="tabPassagePlanClicked()" :title="$t('tabs.pplan')" :title-item-class="getTabStatus()">
                <passage-plan ref="passage-plan" />
              </b-tab>
  
              <!-- <b-tab :title="$t('tabs.weather')" @click="returnToWeather()">
                <weather ref="weather" />
              </b-tab> -->
  
              <!-- Таблица Navarea -->
              <b-tab title="NavArea" @click="tabNavareaClicked()">
                <navarea-table v-if="tabIndex === tabIndexNavarea" ref="navarea-tab" />
              </b-tab>
              <!-- Таблица AIO -->
              <!-- <b-tab title="AIO" @click="tabAIOClicked()">
                <a-i-o-table v-if="tabIndex === tabIndexAIO" ref="aio-tab" />
              </b-tab> -->
            </b-tabs>
          </b-col>
  
          <b-col v-show="displayContent === 'showSearch'" order="4" order-lg="1" :lg="getTabSize()">
            <h6 align="center" class="mt-2">
              {{ $t('route.search') }}
            </h6>
            <b-button class="border-0 float-right" size="sm" variant="outline-danger"
              @click="displayContent = 'showRoute'">
              <b-icon icon="x" font-scale="1.5" />
            </b-button>
            <br>
            <br>
            <search ref="search-panel" />
          </b-col>
  
          <b-col v-show="displayContent === 'showSettings1'" order="4" order-lg="1" :lg="getTabSize()">
            <h6 align="center" class="mt-2">
              {{ $t('route.settings') }}
            </h6>
            <b-button class="border-0 float-right" size="sm" variant="outline-danger" @click="
                                              displayContent = 'showRoute'
                                              okPressed()
                                            ">
              <b-icon icon="x" font-scale="1.5" />
            </b-button>
            <br>
            <br>
            <route-settings />
          </b-col>
  
          <b-col v-show="displayContent === 'showSettings'" order="4" order-lg="1" :lg="getTabSize()">
            <h6 align="center" class="mt-2">
              {{ $t('route.settings') }}
            </h6>
            <b-button class="border-0 float-right" size="sm" variant="outline-danger" @click="
                                              displayContent = 'showRoute'
                                              restoreSearch()
                                            ">
              <b-icon icon="x" font-scale="1.5" />
            </b-button>
            <br>
            <br>
            <route-settings />
          </b-col>
  
          <b-col v-if="displayContent === 'showInfo'" order="4" order-lg="1" :lg="getTabSize()">
            <h6 align="center" class="mt-2">
              {{ $t('route.mapInfo') }}
            </h6>
            <b-button class="border-0 float-right" size="sm" variant="outline-danger" @click="closeMapInfo()">
              <b-icon icon="x" font-scale="1.5" />
            </b-button>
  
            <div v-if="!$store.state.fickle.routes.objectsInfoLoading">
              <b-button v-if="map_info_text.length > 0" class="border-0 float-right" size="sm" variant="outline-secondary"
                @click="closeMapInfoItem()">
                <b-icon icon="arrow-left-short" font-scale="1.5" />
              </b-button>
              <div v-for="(item, i) in $store.state.fickle.routes.objectsInfo.info">
                <span class="listsmall">
                  <a href="#" @click="showObject(item.id, item.name, item.locationType, i + 1, true)">{{ i + 1 }}: {{
                    item.name }}</a>
                  <br>
                </span>
              </div>
              <hr>
              <div v-html="map_info_text" />
            </div>
            <div class="text-center text-danger my-2" v-else>
              <b-spinner small class="align-middle" />
              <strong>&nbsp;{{ $t('route.loading') }}</strong>
            </div>
          </b-col>
  
          <b-col order="1" order-lg="2" :lg="getMapSize()">
            <div>
              <b-overlay :show="!deviceStore.isDeviceIDExist">
                <template #overlay>
                  <p>{{ $t('route.addShip') }}</p>
                </template>
                <my-map :map="map" :height="map_size" />
              </b-overlay>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
    
    <windy-weather-modal ref="windyWeatherModal" />
  </div>
</template>

<script>
import RoutesMap from '@/views/routes/RoutesMap'
import PassagePlanTable from '@/views/routes/PassagePlanTable.vue'
import RouteSettings from '@/views/routes/RouteSettings.vue'
import RouteTable from '@/views/routes/RouteTable.vue'
import GeneralRouteTable from '@/views/routes/GeneralRouteTable.vue'
// import Weather from '@/views/routes/Weather.vue'
import Search from '@/views/routes/Search.vue'
import WindyWeatherModal from '@/components/WindyWeatherModal.vue'
import { eventBus } from '@/main'
import { routes_map } from '@/main'
import store from '@/store'
import { useMomentaryStore } from '@/stores/momentary'
// import AIOTable from '@/views/routes/AIOTable.vue'
import NavareaTable from '@/views/routes/NavareaTable.vue'
import { useRoutesStore } from '@/stores/routes'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { mapStores } from 'pinia'
import PassagePlan from '@/views/routes/PassagePlan.vue'
import { myAxios } from '@/services/myAxios'
import dayjs from 'dayjs'
import { useLogbookStore } from '@/stores/logbook'
import { useUserStore } from '@/stores/user'
import { useDeviceStore } from '@/stores/device'
import { useFleetStore } from '@/stores/fleet'
import { loadAgreements, loadShips, } from '@/helpers/api'
import * as fxparser from 'fast-xml-parser'
import { updatePlotlyData } from '@/my-leaf/routes/components/route-graphs'
import i18n from '@/i18n'
import pLimit from 'p-limit'
import memoryMonitor from '@/utils/memory-monitor'
import { loadNavarea } from '@/helpers/apiFleet'
import { useWeatherCacheStore } from '@/stores/weatherCache'

pdfMake.vfs = pdfFonts.pdfMake.vfs

export default {
  components: {
    RouteTable,
    MyMap: RoutesMap,
    RouteSettings,
    Search,
    // Weather: Weather,
    GeneralRouteTable,
    // AIOTable,
    NavareaTable,
    PassagePlan,
    PassagePlanTable,
    WindyWeatherModal,
  },
  data() {
    return {
      showNotForNavigation: false,
      show2D: false,
      isNeedCheckSafety: false,
      isNeedCheckSafetyWarning: false,

      showRouteNameModal: false,
      routeNameInput: '',

      pathFile: null,
      routeFile: null,
      zonesFile: null,

      selected_ship: '',
      select_ship_disabled: false,
      ships: [],

      needToRestoreSearch: false,
      preparingPassagePlan: true,

      displayContent: 'showRoute',
      map_info_text: '',
      map_info_object: '',

      windowWidth: window.innerWidth,
      mapHeight: window.innerHeight / 1.2,
      mapHeightMobile: window.innerHeight / 1.8,

      map: routes_map,

      is_catalog_preparing: false,
      is_items_by_route_preparing: false,

      // Флаг для предотвращения автозагрузки overlay-ов при инициализации
      isInitializing: true,

      tabIndexFiles: 0,
      tabIndexGeneralRoute: 1,
      tabIndexWaypoints: 2,
      tabIndexPassagePlanTable: 3,
      tabIndexPassagePlan: 4,
      // tabIndexWeather: 5,
      tabIndexNavarea: 5,
      // tabIndexAIO: 6,

      tabIndex: this.tabIndexWaypoints,

      fields: [
        { key: 'name', label: 'name', type: 'string', tdClass: 'small-black', thClass: 'small-gray' },
        { key: 'lat', label: 'Lat', type: 'number', tdClass: 'small-black', thClass: 'small-gray' },
        { key: 'lon', label: 'Lon', type: 'number', tdClass: 'small-black', thClass: 'small-gray' },
      ],

      show_spinner: false,
      // priceCalculating: false,
      openCellsList: false,
      selectedPeriod: { period_code: '4', period: '3' },

      cellList: '',

      agreement: null,

      selected_ecdis: null,
      // aioLayer: null,
      // activeAIOItem: null,
      isDataLoading: false, // Флаг загрузки данных AIO, Navarea
      dataLoadingMessage: "Updating ..."
    }
  },
  beforeMount() {
    console.log('routes: detaching all event handlers');

    eventBus.$off('switch-wp-tab')
    eventBus.$off('search-on-map')
    eventBus.$off('send-order-route')
    eventBus.$off('show-map-info')
    eventBus.$off('show-waypoints')
    eventBus.$off('save-nogo-zones')
    eventBus.$off('route-cleared')
    eventBus.$off('calculate-ukc')
    eventBus.$off('is-need-check-safety')
    eventBus.$off('show-calculate-time')
    eventBus.$off('switch-to-general-route');
    eventBus.$off('switch-to-wp');
    eventBus.$off('graph-diag-changed');
    eventBus.$off('clear-general-route-layers');
    eventBus.$off('draw-map-layers');
    eventBus.$off('map-drag-offset');
  },
  mounted() {
    myAxios.get('/api/v1/manage/test')

    // Инициализируем мониторинг памяти
    memoryMonitor.takeSnapshot('Routes Index Mounted')
    memoryMonitor.setRouteTabBaseline()
    memoryMonitor.startAutoMonitoring(60000) // Каждую минуту

    window.onresize = () => {
      this.windowWidth = window.innerWidth
    }

    eventBus.$off('switch-wp-tab')
    eventBus.$off('search-on-map')
    eventBus.$off('send-order-route')
    eventBus.$off('show-map-info')
    eventBus.$off('show-waypoints')
    eventBus.$off('save-nogo-zones')
    eventBus.$off('route-cleared')
    eventBus.$off('calculate-ukc')
    eventBus.$off('is-need-check-safety')
    eventBus.$off('show-calculate-time')
    eventBus.$off('switch-to-general-route')
    eventBus.$off('switch-to-wp')
    eventBus.$off('graph-diag-changed')
    eventBus.$off('clear-general-route-layers')
    eventBus.$off('draw-map-layers')
    eventBus.$off('map-drag-offset')

    eventBus.$on('map-drag-offset', offset => {
      routes_map.offsetCurrentPoints(offset)
    })

    eventBus.$on('map-drag-offset', (offset) => {
      routes_map.offsetCurrentPoints(offset);
    })

    eventBus.$on('show-calculate-time', (time, message) => {
      if (!message) {
        message = 'route.calculatedTime';
      }

      this.$bvModal.msgBoxOk(this.$t(message) + ' ' + time + this.$t('route.seconds'), {
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'primary',
        headerClass: 'd-none',
        bodyClass: 'py-3 text-center rounded-top',
        footerClass: 'p-2 border-top-0 d-flex justify-content-center',
        centered: true,
        contentClass: 'shadow-lg rounded-lg border-0 animate__animated animate__fadeIn overflow-hidden',
        okTitle: this.$t('btn.close'),
        bodyBgVariant: 'white',
      })
    })

    eventBus.$on('route-cleared', () => {
      //TODO

      if (this.routesStore.getShipWaypointsCount === 0) {
        if (this.$refs["passage-plan-table"]) this.$refs["passage-plan-table"].isUKCReady = false
        this.momentaryStore.setUKCLoadedFlag(false)
        routes_map.isUKCmode = false
      }
    })

    eventBus.$on('calculate-ukc', () => {
      // this.$refs['passage-plan-table'].calculateUKC()
    })

    eventBus.$on('is-need-check-safety', flag => {
      this.isNeedCheckSafety = flag
    })

    eventBus.$on('save-nogo-zones', (zones) => {
      //this.saveZoneFile(zones)
    })

    eventBus.$on('switch-wp-tab', () => {
      // TODO
      // this.tabIndex = this.tabIndexWaypoints
    })

    eventBus.$on('switch-to-general-route', () => {
      console.log('switch-to-general-route')
      this.tabIndex = this.tabIndexGeneralRoute
    })

    eventBus.$on('switch-to-wp', () => {
      console.log('switch-to-wp')
      this.tabIndex = this.tabIndexWaypoints
    })

    eventBus.$on('search-on-map', () => {
      this.displayContent = 'showSearch'
    })

    eventBus.$on('show-waypoints', () => {
      this.displayContent = 'showRoute'
    })

    eventBus.$on('show-map-info', payload => {
      this.map_info_text = ''
      this.map_info_object = ''
      store.commit('fickle/setObjectInfo', payload)
      this.displayContent = 'showInfo'
    })

    eventBus.$on('graph-diag-changed', () => {
      this.drawMapLayers()
    })

    eventBus.$on('clear-general-route-layers', () => {
      routes_map.clearBigDataRouteLayers()
      routes_map.clearGeneralRouteLayers()
    })

    // Обработчики для индикатора загрузки AIO данных
    // eventBus.$off('aio-loading-start')
    // eventBus.$off('aio-loading-end')

    // eventBus.$on('aio-loading-start', () => {
    //   this.isDataLoading = true;
    //   this.dataLoadingMessage = "Updating..."
    // })

    // eventBus.$on('aio-loading-end', () => {
    //   this.isDataLoading = false
    // })

    eventBus.$on('draw-map-layers', payload => {
      this.drawMapLayers(payload)
    })

    // Обработчики для WindyWeatherModal
    eventBus.$off('show-windy-weather')
    eventBus.$off('show-windy-weather-error')
    
    eventBus.$on('show-windy-weather', (data) => {
      if (this.$refs.windyWeatherModal) {
        this.$refs.windyWeatherModal.show(data.coordinates, data.time, data.weatherData)
      }
    })
    
    eventBus.$on('show-windy-weather-error', (data) => {
      if (this.$refs.windyWeatherModal) {
        this.$refs.windyWeatherModal.showError(data.error, data.coordinates, data.time)
      }
    })

    // Обработчики для индикатора загрузки Navarea данных
    eventBus.$off('navarea-loading-start')
    eventBus.$off('navarea-loading-end')

    eventBus.$on('navarea-loading-start', () => {
      this.isDataLoading = true;
      this.dataLoadingMessage = "Updating...";
    })

    eventBus.$on('navarea-loading-end', () => {
      this.isDataLoading = false
    })

//    if (this.routesStore.getShipWaypointsCount > 0) routes_map.redrawRoute()


    loadShips().then(() => {
      // loadAgreements().then(() => {
      if (this.deviceStore.isDeviceIDExist) this.selected_ship = this.deviceStore.getDeviceID
        else this.selected_ship = this.userStore.getECDISShips[0]?.value ?? ''
        this.ships = this.userStore.getECDISShips // TODO: cannot call immediately, something is cleaning out route preview
        setTimeout(() => {
          this.tabIndex = this.tabIndexWaypoints

          this.migrateRouteSettings();
          eventBus.$emit('views-routes-initialized');
          
          // Показываем предупреждение "Not for navigation" один раз за сеанс
          if (!sessionStorage.getItem('notForNavigationShown')) {
            this.showNotForNavigation = true;
          }
          
          // Ждем инициализации карты перед выполнением команд
          this.waitForMapInitialization().then(() => {
            routes_map.drawMapLayers();
            routes_map.restoreNoGoZones();
          });

          // Принудительно отключаем overlay-и при инициализации routes
          // eventBus.$emit('toggle-aio-layer', false)
          eventBus.$emit('toggle-navarea-layer', false)
          // eventBus.$emit('aio-loading-end')
          eventBus.$emit('navarea-loading-end')
        }, 1000)
      // })
    })

  },
  watch: {
    pathFile(newVal, oldVal) {
      if (newVal) {
        this.readPath(newVal)
        this.pathFile = ''
      }
    },
    routeFile(newVal, oldVal) {
      if (newVal) {
        // this.readRouteFile(newVal)
        this.readRTZ(newVal)
        this.routeFile = ''
      }
    },
    zonesFile(newVal, oldVal) {
      if (newVal) {
        this.readZonesFile(newVal)
      }
    },
    selected_ship(newVal, oldVal) {
      // Проверяем что routes_map инициализирован
      if (!routes_map.isInitialized) {
        console.warn('selected_ship watcher: routes_map not initialized yet, skipping');
        return;
      }
      
      routes_map.clearRoute(true, true, false)
      this.deviceStore.selectDevice(newVal)
      routes_map.redrawRoute()
      routes_map.boundRoute()
      routes_map.drawLogbookState()
    },
    'routesStore.getShipWaypointsCount'(newVal, oldVal) {
      /*
      if (newVal > 1 && oldVal <= 1) {
        this.tabs[this.tabIndexPassagePlan].disabled = false
      }
      if (newVal <= 1 && oldVal > 1) {
        this.tabs[this.tabIndexPassagePlan].disabled = true
      }
      */
    },
    tabIndex(newVal, oldVal) {
      // Мониторинг памяти при переключении табов
      const tabNames = {
        0: 'files',
        1: 'generalRoute',
        2: 'waypoints',
        3: 'ukc',
        4: 'pplan',
        // 5: 'weather',
        5: 'navarea',
        // 6: 'aio'
      }

      const fromTab = tabNames[oldVal] || `tab-${oldVal}`
      const toTab = tabNames[newVal] || `tab-${newVal}`

      // Регистрируем переключение таба для отслеживания утечек памяти
      memoryMonitor.registerTabSwitch(fromTab, toTab)

      // Скрываем слой AIO, если уходим с его вкладки
      // if (oldVal === this.tabIndexAIO && newVal !== this.tabIndexAIO) {
      //   eventBus.$emit('toggle-aio-layer', false)
      // }
      // Скрываем слой Navarea, если уходим с его вкладки
      if (oldVal === this.tabIndexNavarea && newVal !== this.tabIndexNavarea) {
        eventBus.$emit('toggle-navarea-layer', false)
      }

      this.momentaryStore.isFolio = false

      this.select_ship_disabled = false
      if (newVal === this.tabIndexWaypoints) {
        routes_map.addNoGoLayer()
        routes_map.showControls()
        routes_map.isUKCmode = false
        if (routes_map.map) {
          routes_map.map.closePopup()
        }
      // } else if (newVal === this.tabIndexWeather) {
      //   this.prepareWeather(newVal)
        // routes_map.hideControls()
      } else if (newVal === this.tabIndexPassagePlanTable) {
        // routes_map.hideControls()
        if (this.momentaryStore.isUKCLoaded) routes_map.isUKCmode = true
        // this.show2D = true
        this.$refs['passage-plan-table'].calculateUKC()
      }

      const routeTabIndexes = [this.tabIndexGeneralRoute, this.tabIndexWaypoints]
      if (routeTabIndexes.includes(newVal)) {
        this.routesStore.setActiveRouteTabInfo({
          tabIndex: newVal,
          isGeneralRoute: newVal === this.tabIndexGeneralRoute,
          isNavRoute: newVal === this.tabIndexWaypoints,
        })
        this.drawMapLayers()
      }
    },
  },
  computed: {
    dayjs() {
      return dayjs
    },
    getOverlayOpacity() {
      return this.$store.state.routes.progress.isCalculating ? 0.3 : 0.9
    },
    getProgressTitle() {
      const titleString = this.$store.state.routes.progress.title || 'route.safetyCalculation'
      const localizedTitle = i18n.t(titleString)
      return localizedTitle
    },

    hasRouteValidationMessage() {
      return this.routeValidationMessage !== ''
    },
    routeValidationMessage() {
      return this.$store.state.routes.validation.routeValidationMessage ?? ''
    },

    ...mapStores(useMomentaryStore, useRoutesStore, useLogbookStore, useUserStore, useDeviceStore, useFleetStore),

    is_mobile() {
      return this.windowWidth <= 760
    },
    map_size() {
      if (this.is_mobile) return window.innerHeight / 1.8
      else return window.innerHeight / 1.2
    },
    breadcrumbText() {
      let x = ''
      switch (this.displayContent) {
        case 'showSearch':
          x = this.$t('breadcrumb.ports')
          break
        case 'showRoute':
          x = this.$t('breadcrumb.routes')
          break
        case 'showSettings':
        case 'showSettings1':
          x = this.$t('breadcrumb.settings')
          break
      }

      if (this.displayContent !== 'showRoute') {
        return x
      }

      let y = ''
      switch (this.tabIndex) {
        case this.tabIndexFiles:
          y = this.$t('breadcrumb.files')
          break
        case this.tabIndexGeneralRoute:
          y = this.$t('breadcrumb.general')
          break
        case this.tabIndexWaypoints:
          y = this.$t('breadcrumb.wp')
          break
        case this.tabIndexPassagePlanTable:
          y = this.$t('breadcrumb.ukc')
          break
        case this.tabIndexPassagePlan:
          y = this.$t('breadcrumb.pplan')
          break
        // case this.tabIndexWeather:
        //   y = this.$t('breadcrumb.weather')
        //   break
        case this.tabIndexNavarea:
          y = this.$t('breadcrumb.navarea')
          break
        // case this.tabIndexAIO:
        //   y = this.$t('breadcrumb.aio')
        //   break
        default:
          y = ''
      }

      return y ? `${x} / ${y}` : x
    },
    getShipName() {
      const ship = this.ships.find(s => s.value === this.selected_ship)
      return ship ? ship.text : ''
    },
    hasOwnShipPosition() {
      const pos = this.fleetStore?.selectedShipPosition;
      return Boolean(pos && Number.isFinite(Number(pos.lat)) && Number.isFinite(Number(pos.lon)));
    },
  },
  created() {
    window.addEventListener('keyup', this.handleKeyPress)
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.handleKeyPress)

    // Останавливаем мониторинг памяти и выводим финальный отчет
    memoryMonitor.takeSnapshot('Routes Index Destroying')
    memoryMonitor.logDetailedReport()
    memoryMonitor.stopAutoMonitoring()
  },
  methods: {
    centerMapOnShip() {
      if (!this.hasOwnShipPosition) {
        return;
      }
      const pos = this.fleetStore.selectedShipPosition;
      const lat = Number(pos.lat);
      const lon = Number(pos.lon);
      if (!Number.isFinite(lat) || !Number.isFinite(lon)) {
        return;
      }
      try {
        const leafletMap = routes_map.map;
        if (leafletMap) {
          const currentZoom = leafletMap.getZoom ? leafletMap.getZoom() : 10;
          leafletMap.flyTo([lat, lon], Math.max(currentZoom, 10), { duration: 0.6 });
        }
      } catch (e) {
        console.error('centerMapOnShip error:', e);
      }
    },
    handleNotForNavigationOk() {
      sessionStorage.setItem('notForNavigationShown', 'true');
      this.showNotForNavigation = false;
    },
    // Ждем пока карта не будет инициализирована
    async waitForMapInitialization() {
      let attempts = 0;
      const maxAttempts = 50; // Максимум 5 секунд ожидания
      
      while (!routes_map.isInitialized && attempts < maxAttempts) {
        await new Promise(resolve => setTimeout(resolve, 100));
        attempts++;
      }
      
      if (!routes_map.isInitialized) {
        console.warn('waitForMapInitialization: Timeout waiting for map initialization');
      }
    },
    
    ackRouteValidation() {
      store.commit('routes/setRouteValidationMessage', '')
    },
    migrateRouteSettings() {
      if (!this.routesStore.routes) return

      this.routesStore.routes.forEach(route => {
        const routeSettings = route.routeSettings
        if (!routeSettings) return

        while (true) {
          let currentVersion = routeSettings.version ?? 0

          switch (currentVersion) {
            case 0:
              routeSettings.graphRouteScoreFactor = 0.8
              routeSettings.landAroundScoreFactor = 1.7
              routeSettings.version = 1
              break
            case 1:
              routeSettings.linkHeuristicFactor = 1
              routeSettings.version = 2
              break
            case 2:
            case 3:
              routeSettings.nearestPointsNumber = 30
              routeSettings.version = 4
              break
          }

          if (currentVersion == routeSettings.version) break
        }
      })
    },
    handleKeyPress(event) {
      if (event.key === 'Escape') {
        // handle current state
        // order of handlers matters
        // hey should stack on top of each other follow the app logic
        if (routes_map.map) {
          routes_map.map.closePopup()
        }

        if (routes_map.waypoints.length == 1) {
          routes_map.selectWaypoint(undefined);
          routes_map.clearRoute();
          this.drawMapLayers();
          return;
        }

        if (routes_map.isBaypassMode || routes_map.selecteBaypassWaypoints.length) {
          if (routes_map.map) {
            routes_map.map.closePopup()
          }
          routes_map.clearBypass()
          routes_map.isBaypassMode = false // TODO: reset flag in clearBypass
          this.drawMapLayers()
          return
        }

        if (routes_map.selectedWaypointIndex !== undefined) {
          routes_map.selectWaypoint(undefined);
          this.drawMapLayers();
          return;
        }
      }
    },
    // Загрузка AIO данных при переключении на таб AIO
    // async loadAIOData() {
    //   try {
    //     // Показываем индикатор загрузки
    //     eventBus.$emit('aio-loading-start')
    //     // Загружаем AIO данные
    //     await loadAIO()
    //     // Кидаем событие для отображения AIO на карте
    //     eventBus.$emit('toggle-aio-layer', true)
    //   } catch (error) {
    //     console.error('Error loading AIO data:', error)
    //   } finally {
    //     // Скрываем индикатор загрузки
    //     eventBus.$emit('aio-loading-end')
    //   }
    // },
    // Загрузка Navarea данных при переключении на таб Navarea
    async loadNavareaData() {
      try {
        // Проверяем, смонтирован ли RoutesMap компонент
        if (!this.$refs['route-tab'] && !this.$refs['generalRoute-tab']) {
          return
        }

        // Показываем индикатор загрузки
        eventBus.$emit('navarea-loading-start')
        // Загружаем Navarea данные
        await loadNavarea()
        // Кидаем событие для отображения Navarea на карте
        eventBus.$emit('toggle-navarea-layer', true)
      } catch (error) {
        console.error('Error loading Navarea data:', error)
      } finally {
        // Скрываем индикатор загрузки
        eventBus.$emit('navarea-loading-end')
      }
    },
    IS_DEVBUILD() {
      return process.env.VUE_APP_DEVBUILD === 'true'
    },
    updateGraph(cellName, isSelected, isClicked = false) {
      updatePlotlyData(cellName, isSelected, isClicked)
    },

    linkClass(idx) {
      if (idx === this.tabIndex) return ['bg-primary', 'text-white']
      else return ['bg-transparent', 'text-primary']
    },
    getMapSize() {
      if (this.tabIndex === this.tabIndexPassagePlanTable) return 6
      else return 8
    },
    getTabSize() {
      if (this.tabIndex === this.tabIndexPassagePlanTable) return 6
      else return 4
    },
    getSelectedShipTooltip() {
      let tooltip = ''
      if (this.$store.state.auth.user.role === 'distributor') {
        let deviceId = this.selected_ship
        let ship = this.ships.find(e => e.value === deviceId)
        tooltip = ship?.email + ', ' + deviceId
      }
      return tooltip
    },
    isUKCReady() {
      return this.momentaryStore.isUKCLoaded
      // return this.$refs['passage-plan-table']?.isUKCReady ?? false
    },

    async getRouteName() {
      this.showRouteNameModal = true
      return new Promise(resolve => {
        this.$once('route-name-entered', routeName => {
          resolve(routeName)
        })
      })
    },
    handleRouteNameOk() {
      this.showRouteNameModal = false
      // this.$emit('route-name-entered', this.routeNameInput);
      this.saveRTZ1(this.routeNameInput)
    },

    saveRTZ() {
      this.routeNameInput = this.routesStore.getRouteName.toLowerCase()
      this.showRouteNameModal = true
    },

    saveRTZ1(fileName) {

      let shipName = this.ships.find(a => a.value === this.selected_ship).text

      let points = this.routesStore.getShipResponse
      console.log('aaa rtz', points)

      let xml = {}
      let waypoints = []
      let lat, lon
      let routeName = this.routesStore.getRouteName
      let portsideXTD = this.routesStore.getShipSettings.xtel
      let starboardXTD = this.routesStore.getShipSettings.xter
      points.calculatedRouteLegs.forEach((point, index) => {
        lat = point.lat
        lon = point.lon

        let waypoint = {
          $name: 'WP' + index,
          position: {
            $lat: lat,
            $lon: lon,
          },
          leg: {
            $portsideXTD: portsideXTD,
            $starboardXTD: starboardXTD,
          },
        }
        waypoints.push({ waypoint: waypoint })
      })
      xml['?xml'] = { $version: '1.0', $encoding: 'utf-8' }
      xml.route = { $version: '1.0' }
      xml.route.routeInfo = {
        $routeName: routeName,
        $vesselName: shipName,
        $vesselIMO: '',
        $vesselDraught: this.routesStore.getShipDraught,
        $vesselHeight: this.routesStore.getShipHeight,
        $vesselWidth: this.routesStore.getShipWidth,
        $vesselLength: this.routesStore.getShipLength,
      }
      xml.route.waypoints = waypoints


      const options = {
        ignoreAttributes: false,
        attributeNamePrefix: '$',
        format: true,
        suppressEmptyNode: true,
        oneListGroup: true,
        arrayNodeName: 'waypoints',
      }

      const builder = new fxparser.XMLBuilder(options)
      let output = builder.build(xml)

      let a = document.createElement('a')
      let file = new Blob([output], { type: 'text/plain' })
      a.href = URL.createObjectURL(file)

      a.download = fileName + '.rtz'
      a.click()

    },

    readPath(file) {
      console.log(file)
      let reader = new FileReader()
      reader.onload = e => {
        let contents = e.target.result
        try {
          const jsonObject = JSON.parse(contents)
          console.log('Parsed JSON:', jsonObject)

          routes_map.calcucaltePathRoute(jsonObject)

          // Process your JSON object here
          // routes_map.loadPathFromJson(jsonObject);
        } catch (error) {
          console.error('Error parsing JSON file:', error)
          this.$bvModal.msgBoxOk('Invalid JSON file format', {
            title: 'File Error',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            centered: true,
          })
        }
      }
      reader.readAsText(file)
    },

    readRTZ(file) {
      let reader = new FileReader()
      reader.onload = async (e) => {
        let contents = e.target.result
        console.log(contents)

        const options = {
          ignoreAttributes: false,
          compact: true,
        }
        const parser = new fxparser.XMLParser(options)
        let xml = parser.parse(contents)
        let points = xml.route.waypoints.waypoint

        let coordinates = []

        console.log('zip xml', points)

        let info = xml.route.routeInfo
        let name = info['@_routeName']
        let draught = Number(info['@_vesselDraught'])
        let length = Number(info['@_vesselLength'])
        let height = Number(info['@_vesselHeight'])
        let width = Number(info['@_vesselWidth'])

        // убираем нулевые значения
        const defaultIfZeroOrMissing = (val, def) => {
          if (val === undefined || val === null || isNaN(val) || Number(val) === 0) return def
          return val
        }

        draught = defaultIfZeroOrMissing(draught, 1)
        height = defaultIfZeroOrMissing(height, 1)
        width = defaultIfZeroOrMissing(width, 1)
        length = defaultIfZeroOrMissing(length, 2)

        if (name !== undefined) this.routesStore.getShipSettings.name = name
        if (draught !== undefined) this.routesStore.getShipSettings.draught = Number(draught)
        if (length !== undefined) this.routesStore.getShipSettings.length = Number(length)
        if (height !== undefined) this.routesStore.getShipSettings.height = Number(height)
        if (width !== undefined) this.routesStore.getShipSettings.width = Number(width)

        console.log('info1', info)

        points.forEach(waypoint => {
          let lat = waypoint.position['@_lat']
          let lon = waypoint.position['@_lon']
          let speed = waypoint?.['@_speed'] ?? '0'

          if (speed.length > 10) {
            speed = '3'
            waypoint['@_speed'] = speed
          }

          coordinates.push({ lat: lat, lon: lon, speed: speed })
        })

        console.log('info2', coordinates)

        this.routesStore.addImportedRoute(points)

        console.log('zip xml', coordinates)

        this.$refs['passage-plan-table'].isUKCReady = false
        this.momentaryStore.setUKCLoadedFlag(false)
        routes_map.clearRoute()
        this.isDataLoading = true;

        await routes_map.createImportedRoute(
          coordinates,
          (i, count) => {
            this.dataLoadingMessage = `Loading waypoints (${i}/${count}) ...`;
          }
        )
                
        this.isDataLoading = false;

        // routes_map.redrawRoute()
        routes_map.boundRoute()

        this.tabIndex = this.tabIndexWaypoints

        routes_map.checkSafety()
      }
      reader.readAsText(file)
    },

    readRouteFile(file) {
      let reader = new FileReader()
      reader.onload = e => {
        let contents = e.target.result
        let jsonContents = JSON.parse(contents)
        this.routesStore.restoreShipRouteSettings(jsonContents.routeSettings)
        this.routesStore.restoreShipRouteResponse(jsonContents.routeResponse)
        routes_map.redrawRoute()
        routes_map.boundRoute()
        this.tabIndex = this.tabIndexWaypoints
        this.routeFile = null
      }
      reader.readAsText(file)
    },

    readZonesFile(file) {
      let reader = new FileReader()
      reader.onload = e => {
        let contents = e.target.result
        let jsonContents = JSON.parse(contents)
        console.log(jsonContents)
        this.routesStore.addNoGoZone(jsonContents)
        routes_map.restoreNoGoZones()
        this.zonesFile = null
      }
      reader.readAsText(file)
    },
    loadRouteFile: () => {
      document.getElementById('upload-route').click()
    },
    loadPathFile: () => {
      document.getElementById('upload-path').click()
    },
    loadZonesFile: () => {
      document.getElementById('upload-zones').click()
    },
    saveRouteFile() {
      let jsonData = JSON.stringify({
        routeResponse: this.routesStore.getShipResponse,
        routeSettings: this.routesStore.getShipSettings,
      })
      let a = document.createElement('a')
      let file = new Blob([jsonData], { type: 'text/plain' })
      a.href = URL.createObjectURL(file)
      a.download = 'route.txt'
      a.click()
    },
    saveZoneFile(zones) {
      let jsonData = JSON.stringify(zones)
      let a = document.createElement('a')
      let file = new Blob([jsonData], { type: 'text/plain' })
      a.href = URL.createObjectURL(file)
      a.download = 'zones.txt'
      a.click()
    },
    reloadPage() {
      window.location.reload()
    },
    restoreSearch() {
      if (this.needToRestoreSearch) this.$refs['search-panel'].showCalculateModal = true
    },
    routePointInfos(index) {
      return this.routesStore.getShipWaypoints[index].info
    },
    dateu(seconds) {
      let date = this.routesStore.getShipStartDate
      let time = this.routesStore.getShipStartTime
      let datetime = dayjs(date + ' ' + time, 'YYYY-MM-DD HH:mm')
      let datetimenew = datetime.add(seconds, 'seconds')
      let shortdate = datetimenew.unix()

      return shortdate
    },
    // Получение данных о погоде для всех точек маршрута
    async prepareWeather() {
      if (this.routesStore.getShipWaypointsCount === 0) {
        return
      }

      this.isDataLoading = true;
      this.dataLoadingMessage = "Loading weather...";

      const pts = this.routesStore.getShipWaypoints
      this.routesStore.initWeather(pts.length)

      const weatherCacheStore = useWeatherCacheStore();

      const weatherData = []
      const limit = pLimit(10)
      let weatherPointsLoaded = 0;

      const tasks = pts.map((coordinates, i) => {
        return limit(async () => {
          const lat = coordinates.lat
          const lon = coordinates.lon
          const datetime = this.dateu(this.routePointInfos(i).fromStartSeconds ?? 0)

          weatherData[i] = await weatherCacheStore.loadPointWeatherAsync(lat, lon, datetime);
          weatherPointsLoaded++;

          this.dataLoadingMessage = `Loading weather (${weatherPointsLoaded}/${pts.length}) ...`;
        })
      })

      await Promise.all(tasks)

      this.isDataLoading = false

      this.routesStore.setWeatherBatch(weatherData)
    },
    routingProgress() {
      let progress = this.$store.state.routes.progress.calculatingProgress
      if (progress > 100) progress = 100

      return progress
    },

    getTabStatus() {
      if (this.routesStore.getShipWaypointsCount > 1) return 'aaa12'
      else return 'd-none'
    },
    cancelRoute() {
      routes_map.cancelAutorouting()
    },
    // При клике на таб Passage Plan выключаем AIO слой и скрываем индикатор
    tabPassagePlanClicked() {
      // eventBus.$emit('toggle-aio-layer', false)
      // eventBus.$emit('aio-loading-end')
      eventBus.$emit('toggle-navarea-layer', false)
      eventBus.$emit('navarea-loading-end')
      this.$refs['passage-plan'].createPDF()
    },
    // При клике на таб AIO загружаем AIO данные
    // tabAIOClicked() {
    //   eventBus.$emit('init-weather')
    //   eventBus.$emit('toggle-navarea-layer', false)
    //   eventBus.$emit('navarea-loading-end')
    //   // Закрываем Navarea popup при переключении на AIO таб
    //   eventBus.$emit('close-navarea-tooltip')
    //   this.loadAIOData()
    // },
    // При клике на таб Navarea загружаем Navarea данные
    tabNavareaClicked() {
      eventBus.$emit('init-weather')
      // eventBus.$emit('toggle-aio-layer', false)
      // eventBus.$emit('aio-loading-end')
      // Закрываем AIO popup при переключении на Navarea таб
      eventBus.$emit('close-aio-popup')
      this.loadNavareaData()
    },
    // При клике на любой другой таб выключаем AIO и Navarea слои и скрываем индикатор
    tabNonAIOClicked() {
      eventBus.$emit('init-weather')
      // eventBus.$emit('toggle-aio-layer', false)
      // eventBus.$emit('aio-loading-end')
      eventBus.$emit('toggle-navarea-layer', false)
      eventBus.$emit('navarea-loading-end')
      // Закрываем popup'ы при переключении с AIO/Navarea табов на любой другой
      // eventBus.$emit('close-aio-popup')
      eventBus.$emit('close-navarea-tooltip')
    },

    showPorts() {
      this.displayContent = 'showSearch'
    },
    showRoutes() {
      this.displayContent = 'showRoute'
    },
    showSettings() {
      this.displayContent = 'showSettings'
    },
    showSettings1() {
      this.displayContent = 'showSettings1'
    },
    getRouteButtonStatus(type) {
      if (this.displayContent === 'showRoute' && type === 'routes') return 'primary'
      else return 'outline-primary'
    },
    // При клике на таб Weather выключаем AIO и Navarea слои и скрываем индикатор
    returnToWeather() {
      // eventBus.$emit('toggle-aio-layer', false)
      // eventBus.$emit('aio-loading-end')
      eventBus.$emit('toggle-navarea-layer', false)
      eventBus.$emit('navarea-loading-end')
      eventBus.$emit('show-weather')
      eventBus.$emit('init-weather')
    },

    closeMapInfo() {
      this.displayContent = 'showRoute'
      routes_map.clearInfoObjects()
    },
    closeMapInfoItem() {
      this.map_info_text = ''
      this.map_info_object = ''
      routes_map.clearInfoObjects()
    },
    showObject(id, name, type, i, needZoom) {
      this.map_info_text = "<span class='small-cyan'>" + i + ': ' + name + ' (' + type + ')</span><hr>'
      this.map_info_object = id

      this.$store.state.fickle.routes.objectsInfo.info.forEach((item, index) => {
        if (item.name === name && i - 1 === index) {
          this.map_info_text += ''
          item.attributes.forEach((attribute, i) => {
            this.map_info_text += "<span class='listsmall'>" + attribute.name + ":</span> <span class='small-black'>" + attribute.value + '</span><br>'
          })
          this.map_info_text += '<hr>'
        }
      })

      let points = this.$store.state.fickle.routes.objectsInfo.info.filter(function (e) {
        return e['id'] === id
      })

      let lines = points[0].lines

      routes_map.drawInfoObject({ lines: lines, type: type, zoom: needZoom })
    },

    changeSettings() {
      this.show2D = false
      this.showSettings1()
    },
    okPressed() {
      this.show2D = false

      if (this.isNeedCheckSafety) {
        this.tabIndex = this.tabIndexWaypoints
        this.isNeedCheckSafetyWarning = true
      } else {
        this.$refs['passage-plan-table'].calculateUKC()
      }
    },
    cancelPressed() {
      this.show2D = false
      this.tabIndex = this.tabIndexWaypoints
    },
    drawMapLayers() {
      // Проверяем что routes_map инициализирован
      if (!routes_map.isInitialized) {
        console.warn('drawMapLayers: routes_map not initialized yet, skipping');
        return;
      }

      routes_map.clearBigDataRouteLayers()
      routes_map.clearGeneralRouteLayers()
      routes_map.removeWaypointsLayers()

      const routeTabIndex = this.routesStore.activeRouteTabInfo.tabIndex
      if (routeTabIndex == this.tabIndexGeneralRoute) {
        routes_map.drawBigDataRoute()
        routes_map.drawGeneralRoute()
      }

      if (routeTabIndex == this.tabIndexWaypoints) {
        routes_map.addWaypointsLayers()
      }

      routes_map.showControls()
      routes_map.initTooltips()
    },
  },
}
</script>

<style scoped>
@import '@/assets/styles/components/buttons.css';

/* Warning Modal Styles - based on Agreement Modal design */
::v-deep #warning-modal .modal-header {
  background: linear-gradient(135deg, #fff4f4 0%, #ffe9e9 100%);
  border-bottom: none;
  padding: 18px 22px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  box-shadow: inset 0 -1px 0 rgba(169, 0, 33, 0.12);
}

::v-deep #warning-modal .modal-header .close {
  color: #d6445f;
  opacity: 0.75;
  text-shadow: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

::v-deep #warning-modal .modal-header .close:hover {
  opacity: 1;
  transform: scale(1.05);
}

.warning-modal-title {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-family: 'Roboto', 'Helvetica Neue', 'Segoe UI', sans-serif;
}

.warning-modal-title .title-label {
  color: #a90021;
  font-size: 1.05rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  display: flex;
  align-items: center;
  gap: 8px;
}

.warning-modal-title .title-label i {
  font-size: 1.1rem;
}

.warning-card {
  background: #ffffff;
  border: 1px solid #ffe5ea;
  border-radius: 16px;
  box-shadow: 0 12px 28px rgba(169, 0, 33, 0.14);
  padding: 20px 22px;
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.warning-content {
  display: flex;
  gap: 18px;
  align-items: flex-start;
}

.warning-icon {
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffe5ea, #ffd0d8);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a90021;
  font-size: 1.8rem;
  box-shadow: 0 6px 16px rgba(169, 0, 33, 0.15);
}

.warning-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.warning-heading {
  color: #a90021;
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  margin: 0;
  text-transform: uppercase;
}

.warning-description {
  color: #4a5266;
  font-size: 0.92rem;
  line-height: 1.6;
  margin: 0;
}

.acknowledge-button {
  font-weight: 600;
  letter-spacing: 0.01em;
  padding: 10px;
  font-size: 0.95rem;
  background: linear-gradient(135deg, #4b5fdd, #3a4bc4);
  border: none;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(75, 95, 221, 0.25);
  transition: all 0.2s ease;
}

.acknowledge-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(75, 95, 221, 0.35);
  background: linear-gradient(135deg, #5a6fe7, #4b5fdd);
}

@media (max-width: 576px) {
  .warning-card {
    padding: 16px;
  }

  .warning-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .warning-icon {
    width: 50px;
    height: 50px;
    font-size: 1.5rem;
  }

  .warning-heading {
    font-size: 1.2rem;
  }
}

:deep(.compact-tabs .nav-tabs) {
  border-bottom: 1px solid #d1d9e6;
  display: flex;
  flex-wrap: wrap;
  /* Changed from nowrap to wrap */
  overflow-x: visible;
  /* Changed from auto to visible */
  overflow-y: visible;
  /* Changed from hidden to visible */
  scrollbar-width: thin;
  padding: 0.15rem 0.15rem 0;
}

:deep(.compact-tabs .nav-tabs .nav-item) {
  margin-bottom: 3px;
  /* Add some bottom margin for wrapped items */
  white-space: nowrap;
  flex: 0 0 auto;
  margin-right: 1px;
}

:deep(.compact-tabs .nav-link) {
  padding: 0.3rem 0.6rem;
  font-size: 0.8rem;
  border-radius: 0.4rem 0.4rem 0 0;
  transition: all 0.2s ease;
  border: 1px solid #e9ecef;
  border-bottom: none;
  color: #5a6a85;
}

:deep(.compact-tabs .nav-link:hover:not(.active)) {
  background-color: rgba(108, 117, 125, 0.08);
  border-color: #e2e8f0;
  color: #495057;
}

:deep(.compact-tabs .nav-link.active) {
  background-color: #f8f9fa;
  background-image: linear-gradient(to bottom, #ffffff, #f8f9fa);
  border-color: #d1d9e6;
  color: #3a3f51;
  font-weight: 500;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.03);
}

:deep(.compact-tabs .tab-content) {
  border: 1px solid #d1d9e6;
  border-top: none;
  padding: 0.75rem 0.2rem;
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  background-color: #ffffff;
}

/* Hide scrollbar for Chrome/Safari */
:deep(.compact-tabs .nav-tabs::-webkit-scrollbar) {
  height: 3px;
  width: 0;
}

:deep(.compact-tabs .nav-tabs::-webkit-scrollbar-thumb) {
  background: rgba(108, 117, 125, 0.2);
  border-radius: 3px;
}

:deep(.tab-content)>.tab-pane {
  padding: 0;
}

:deep(.compact-tabs .tab-pane) {
  padding-top: 0.5rem;
}
</style>

